module.exports = __webpack_public_path__ + "img/HistorischeDaten.2e3f0380.png";